import { getComposeEvent, getOriginalEvent } from 'owa-calendar-compose-store-manager';
import isDirty from '../utils/isDirty';
import {
    discardQuickComposeEvent,
    dismissQuickComposeIfNotDirty,
} from 'owa-calendar-compose-form-actions';
import isQuickComposeOpen from 'owa-calendar-compose-form-store/lib/selectors/isQuickComposeOpen';
import { orchestrator } from 'satcheljs';

/**
 * Checks if the form is QuickCompose and not dirty and dismisses the QuickCompose if true
 */
export default orchestrator(dismissQuickComposeIfNotDirty, actionMessage => {
    const event = getComposeEvent(actionMessage.formId);
    const originalEvent = getOriginalEvent(actionMessage.formId);
    const isEventDirty = isDirty(event, originalEvent, false /*shouldIgnoreAttachments*/);
    if (isQuickComposeOpen(actionMessage.formId) && !isEventDirty) {
        discardQuickComposeEvent(actionMessage.formId);
    }
});
